import { Reorder, useDragControls } from "framer-motion";
import { GripVertical, Save, Trash2 } from "lucide-react";
import { photoSrc } from "@/lib/api";

const fieldCls = "w-full rounded-lg border border-gold/30 px-2.5 py-1.5 text-xs outline-none focus:border-gold";

export default function PhotoCard({ p, edit, onEdit, onSave, onRemove, confirmDelete, onAskDelete, onDragEndPersist }) {
  const controls = useDragControls();
  return (
    <Reorder.Item
      as="li"
      value={p}
      dragListener={false}
      dragControls={controls}
      onDragEnd={onDragEndPersist}
      whileDrag={{ scale: 1.04, zIndex: 30, boxShadow: "0 24px 50px -12px rgba(123,45,78,0.45)" }}
      className="overflow-hidden rounded-2xl border border-gold/30 bg-white shadow-sm"
      data-testid={`admin-photo-${p.id}`}
    >
      <div className="relative">
        <img src={photoSrc(p.url)} alt={p.caption || "cake"} draggable={false} className="h-44 w-full object-cover" />
        <button
          onPointerDown={(e) => controls.start(e)}
          aria-label="Drag to reorder"
          data-testid={`photo-drag-handle-${p.id}`}
          className="absolute right-2 top-2 cursor-grab touch-none rounded-full bg-white/90 p-1.5 text-wine shadow transition-colors hover:text-golddeep active:cursor-grabbing"
        >
          <GripVertical className="h-4 w-4" />
        </button>
      </div>
      <div className="space-y-2 p-3">
        <input value={edit.caption} onChange={(e) => onEdit({ caption: e.target.value })} placeholder="Caption" data-testid={`photo-edit-caption-${p.id}`} className={fieldCls} />
        <input value={edit.tags} onChange={(e) => onEdit({ tags: e.target.value })} placeholder="tags, comma, separated" data-testid={`photo-edit-tags-${p.id}`} className={fieldCls} />
        <div className="flex items-center justify-between pt-1">
          <button onClick={onSave} data-testid={`photo-save-${p.id}`}
            className="flex items-center gap-1 rounded-full border border-gold/50 px-3 py-1 text-xs font-medium text-golddeep transition-all hover:bg-gold hover:text-white">
            <Save className="h-3 w-3" /> Save
          </button>
          {confirmDelete ? (
            <button onClick={onRemove} data-testid={`photo-delete-confirm-${p.id}`} className="rounded-full bg-red-600 px-3 py-1 text-xs font-semibold text-white">
              Sure?
            </button>
          ) : (
            <button onClick={onAskDelete} aria-label="Remove photo" data-testid={`photo-delete-${p.id}`}
              className="flex items-center gap-1 rounded-full border border-red-200 px-3 py-1 text-xs font-medium text-red-600 transition-all hover:bg-red-50">
              <Trash2 className="h-3 w-3" /> Remove
            </button>
          )}
        </div>
      </div>
    </Reorder.Item>
  );
}
